import { Howl } from 'howler'
import SpeakerIcon from '@/components/SpeakerIcon'

export default (config = {}) => {
  return {
    components: {
      SpeakerIcon,
    },
    data () {
      return {
        audioMap: [],
        isPlaying: -1,
      }
    },
    beforeDestroy () {
      this.audioStop()
      this.audioUnload()
    },
    computed: {
      hasAudio () {
        return this.audioMap.length > 0
      },
    },
    methods: {
      audioLoad (opts) {
        return new Promise((resolve) => {
          const audio = new Howl(opts)
          this.audioMap.push(audio)
          audio.once('load', () => resolve(audio))

          // Trim the trailing sound.
          audio.on('play', () => {
            audio.mute(false)
            const to = setTimeout(() => {
              audio.mute(true)
            }, (audio.duration() * 1000) - 250 - audio.seek())
            audio.once('stop', () => {
              clearTimeout(to)
            })
            audio.once('pause', () => {
              clearTimeout(to)
            })
          })
        })
      },
      enableAudioAutoPlay () {
        const playNext = async (key) => {
          if (key + 1 < this.audioMap.length) {
            await this.audioPlay(key + 1)
          } else {
            this.$emit('audio:autoend')
          }
        }
        this.$on('audio:end', playNext)
      },
      async audioPlay (key) {
        const play = (key) => {
          const audio = this.audioMap[key]
          return new Promise((resolve) => {
            audio.once('end', () => {
              this.isPlaying = -1
              this.$emit('audio:end', key)
              resolve()
            })
            audio.once('stop', () => {
              this.isPlaying = -1
              this.$emit('audio:stop', key)
              resolve()
            })
            this.$emit('audio:play', key)
            this.isPlaying = key
            audio.play()
          })
        }

        if (typeof key == 'undefined' || typeof key == 'null') {
          key = 0
        }
        if (typeof this.audioMap[key] == 'undefined') {
          return
        }

        this.audioStop()
        await play(key)
      },
      audioStop (key = this.isPlaying) {
        if (key > -1) {
          this.audioMap[key].stop()
        }
      },
      audioUnload () {
        this.audioMap.forEach((audio) => audio.unload())
        this.audioMap = []
      },
      parseAudio (audioRaw) {
        const [ audioStr, spriteStr ] = audioRaw.split('?')
        const files = audioStr.split(',').map(file => {
          return { src: file }
        })
        return files
      },
      audioPause (key = this.isPlaying) {
        if (key > -1) {
          this.audioMap[key].pause()
        }
      },
      audioRestart (key = this.isPlaying) {
        if (key > -1) {
          this.audioMap[key].seek(0)
          this.audioMap[key].play()
        }
      },
    },
  }
}
